<template>
  <el-dialog :title="getTitle+'管理'"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-button v-has="'/medium/read'"
               type="primary"
               class="mb-15"
               @click="handleInput">录入{{getTitle}}</el-button>
    <span v-if="timeSHow">关闭倒计时{{time}}</span>
    <el-card v-if="inputShow"
             shadow="none"
             class="mb-15">
      <p class="mb-15"><span class="mb-10">录入信息：</span>{{inputShow}}
      </p>
      <el-button v-has="'/med_fprint/add' || '/med_ic/add' || '/med_id/add' || '/med_fprint/add'"
                 type="primary"
                 @click="handleSubmit">绑定</el-button>
    </el-card>
    <el-card shadow="none">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData">
        <el-table-column label="序号"
                         type="index"
                         width="60"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <template v-if="data.from === 'ic' || data.from === 'id'">
              <el-button v-has="'/med_id/edit' || '/med_ic/edit'"
                         v-if="scope.row.status === '1'"
                         size="mini"
                         type="primary"
                         @click="handleLost(scope.row)">挂失</el-button>
              <el-button v-has="'/med_id/edit' || '/med_ic/edit' || '/med_fvein/edit' || '/med_fprint/edit'"
                         v-if="scope.row.status === '2'"
                         plain
                         size="mini"
                         type="primary"
                         @click="handleRefound(scope.row)">解挂</el-button>
            </template>
            <el-button v-has="'/med_id/edit' || '/med_ic/edit' || '/med_fvein/edit' || '/med_fprint/edit'"
                       size="mini"
                       type="danger"
                       @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
import mediumApi from '@/common/medium'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      timeSHow: false,
      time: 45,
      inputDetail: '',
      inputInfo: '',
      inputShow: '',
      tableTitle: [
        {
          prop: 'svalue',
          name: '录入信息',
          width: '100'
        }
      ],
      tableData: [],
      randomNum: '',
      timeObj: null
    }
  },
  computed: {
    getTitle() {
      return this.data.from === 'ic'
        ? 'IC卡'
        : this.data.from === 'cpu'
        ? '员工卡'
        : this.data.from === 'fprint'
        ? '指纹'
        : this.data.from === 'fvein'
        ? '静脉'
        : '身份证'
    }
  },
  created() {
    this.getData()
  },
  beforeDestroy() {
    if (this.randomNum) {
      this.cancelInput()
    }
  },
  methods: {
    getData() {
      this.getInfo()
    },
    // 取消录入
    cancelInput() {
      mediumApi
        .cancelMediumInfo({
          medType: this.data.from,
          medTag: this.randomNum
        })
        .then((data) => {
          data.procData(
            data.res,
            () => {
              this.randomNum = ''
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      clearInterval(this.timeObj)
    },
    // 录入信息
    handleInput() {
      // loading倒计时提醒
      this.time = 45
      this.timeSHow = true
      this.timeObj = setInterval(() => {
        if (this.time > 0) {
          this.time--
        }
        if (this.time <= 0) {
          this.cancelInput()
        }
      }, 1000)
      this.randomNum = this.getRandomNum()
      mediumApi
        .getMediumInfo(
          {
            medType:
              this.data.from === 'cpu'
                ? 'ic_cpu'
                : this.data.from === 'id'
                ? 'ic_iden'
                : this.data.from === 'ic'
                ? 'ic_ic'
                : this.data.from,
            medTag: this.randomNum
          },
          { timeout: 45000 }
        )
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (data.medTag === this.randomNum) {
                this.randomNum = ''
                this.inputInfo = data.medValue
                if (typeof data.medDetail !== 'undefined') {
                  this.inputDetail = data.medDetail
                }
                if (data.medValue.length > 32) {
                  this.inputShow = data.medValue.substring(0, 32) + '...'
                } else {
                  this.inputShow = data.medValue
                }
                this.$message.success('读取成功')
              }
              this.timeSHow = false
              clearInterval(this.timeObj)
            },
            (err) => {
              this.timeSHow = false
              clearInterval(this.timeObj)
              this.$message.error(err)
            }
          )
        })
    },
    // 绑定
    handleSubmit() {
      let type = ''
      switch (this.data.from) {
        case 'ic':
          type = 'addIc'
          break
        case 'cpu':
          type = 'addIc'
          break
        case 'fprint':
          type = 'addFprint'
          break
        case 'fvein':
          type = 'addFvein'
          break
        case 'id':
          type = 'addId'
          break
        default:
          break
      }
      if (type) {
        this.submitInfo(type)
      }
    },
    // 挂失
    handleLost(data) {
      let type = ''
      switch (this.data.from) {
        case 'ic':
          type = 'editIc'
          break
        case 'cpu':
          type = 'editIc'
          break
        case 'fprint':
          type = 'editFprint'
          break
        case 'fvein':
          type = 'editFvein'
          break
        case 'id':
          type = 'editId'
          break
        default:
          break
      }
      this.dealInfo(type, { id: data.id, status: '2', svalue: data.svalue })
    },
    // 解挂
    handleRefound(data) {
      let type = ''
      switch (this.data.from) {
        case 'ic':
          type = 'editIc'
          break
        case 'cpu':
          type = 'editIc'
          break
        case 'fprint':
          type = 'editFprint'
          break
        case 'fvein':
          type = 'editFvein'
          break
        case 'id':
          type = 'editId'
          break
        default:
          break
      }
      this.dealInfo(type, { id: data.id, status: '1', svalue: data.svalue })
    },
    // 删除
    handleDelete(data) {
      let type = ''
      switch (this.data.from) {
        case 'ic':
          type = 'delIc'
          break
        case 'cpu':
          type = 'delIc'
          break
        case 'fprint':
          type = 'delFprint'
          break
        case 'fvein':
          type = 'delFvein'
          break
        case 'id':
          type = 'delId'
          break
        default:
          break
      }
      this.dealInfo(type, { id: data.id, svalue: data.svalue })
    },
    handleCancel() {
      this.$emit('handleClose')
    },
    // 获取数据
    getInfo() {
      let type = ''
      let param = {}
      switch (this.data.from) {
        case 'ic':
          type = 'getIcList'
          param = { person_id: this.data.id, mode: 2 }
          break
        case 'cpu':
          type = 'getIcList'
          param = { person_id: this.data.id, mode: 1 }
          break
        case 'fprint':
          type = 'getFprintList'
          param = { person_id: this.data.id }
          break
        case 'fvein':
          type = 'getFveinList'
          param = { person_id: this.data.id }
          break
        case 'id':
          type = 'getIdList'
          param = { person_id: this.data.id }
          break
        default:
          break
      }
      fetch[type](param).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tableData = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 绑定
    submitInfo(type) {
      fetch[type]({
        svalue: this.inputInfo,
        person_id: this.data.id,
        med_detail: this.inputDetail
      }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.inputDetail = ''
            this.inputInfo = ''
            this.inputShow = ''
            this.$message.success('录入成功')
            this.getData()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 处理信息
    dealInfo(type, data) {
      fetch[type]({ ...data, person_id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
            this.getData()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    getRandomNum() {
      let randomNum = new Date().getTime() + ''
      let tmpLen = randomNum.length
      let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = $chars.length
      for (var i = 0; i < 32 - tmpLen; i++) {
        randomNum += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return randomNum
    }
  }
}
</script>

<style></style>
